import { Fragment, RefObject } from 'react';
import { LinkedInLightGrayIcon } from '../../assets';
import './FooterSection.scss';
import video from '../../assets/images/mini/waves-gold-mini-v2.mp4';

const HOME_COUNTRIES = ['United States', 'Poland', 'Canada', 'Mexico', 'Brazil'];

type FooterSectionProps = {
  ref?: RefObject<HTMLDivElement | null>;
  screenId?: string;
};

export const FooterSection = ({ screenId, ref }: FooterSectionProps) => {
  const currentYear = new Date().getFullYear();
  return (
    <div className='contact-info' id={screenId} ref={ref}>
      <video src={video} autoPlay loop muted playsInline />
      <div className='contact-info__content'>
        <div className='description'>
          <h3 className='text'>What are you waiting for?</h3>
          <h3 className='text-emphasis'>Let’s work together.</h3>
        </div>
        <div className='contacts'>
          <div className='mail'>
            <a href='mailto:makeitwork@c4workx.com'>makeitwork@c4workx.com</a>
          </div>
          <div className='social-medias'>
            <a href='https://www.linkedin.com/company/c4workx/' target='_blank' rel='noreferrer'>
              <img className='icon' src={LinkedInLightGrayIcon} alt="C4Workx's LinkedIn page" />
            </a>
          </div>
          <div className='find-us'>
            <div className='homes'>
              <h6>Our homes</h6>
              <p>
                {HOME_COUNTRIES.map((country, index) => {
                  const isLastCountry = index === HOME_COUNTRIES.length - 1;
                  return (
                    <Fragment key={country}>
                      {country}
                      {!isLastCountry ? (
                        <>
                          <span className='spacing' />|<span className='spacing' />
                        </>
                      ) : null}
                    </Fragment>
                  );
                })}
              </p>
            </div>
            <div className='contact-us'>
              <h6>Joining C4Workx</h6>
              <p>Are you dynamite enough? Send us an e-mail</p>
            </div>
          </div>
        </div>
        <h5 className='rights-reserved'>© {currentYear} C4Workx. All rights reserved</h5>
      </div>
    </div>
  );
};
